/**
 * Date display helpers. PSA shows all dates as US `mm/dd/yyyy`.
 *
 * Date-only ISO values (`yyyy-mm-dd`, e.g. a work date or billing cursor) are formatted
 * directly from their parts so they never shift across time zones. Full ISO timestamps
 * are rendered in the viewer's local time.
 */

const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

const DATE_OPTS: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
};

const DATE_TIME_OPTS: Intl.DateTimeFormatOptions = {
  ...DATE_OPTS,
  hour: 'numeric',
  minute: '2-digit',
};

/** Formats a date(-only) value as `mm/dd/yyyy`, or `—` when empty/invalid. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  if (DATE_ONLY_RE.test(value)) {
    const [year, month, day] = value.split('-');
    return `${month}/${day}/${year}`;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleDateString('en-US', DATE_OPTS);
}

/** Formats an ISO timestamp as `mm/dd/yyyy, h:mm AM/PM` (local), or `—` when empty. */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleString('en-US', DATE_TIME_OPTS);
}
